import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

import { CircularLoader } from '../../loaders';

interface ICameraLoaderProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a loading indicator when the camera is being initialized.
 */
export function CameraLoader({ className }: ICameraLoaderProps) {
  return (
    <div
      className={`
        absolute top-0 left-0 flex h-full  w-full flex-col items-center
        ${className}
      `}
    >
      <CircularLoader className="my-20 h-16 w-16 p-8 sm:my-20" />
      <h1 className="text-primary-500 font-light">
        <Text text={translations.camera.refreshingCamera} />
      </h1>
      <p className="text-gray-500">
        <Text text={translations.camera.refreshPleaseWait} />
      </p>
    </div>
  );
}
